<template>
    <div class="animated fadeIn">
    
        <ChangeControlUnitComponent v-if="!$store.state.currentUnit.id" />
        <ChangeControlHeaderComponent v-if="$store.state.currentUnit.id" />

        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                <b-card header="ENTRADA DE DENOMINAÇÕES PARA TROCA">
                    <b-row>
                        <b-col sm="5">
                            <h4 id="traffic" class="card-title mb-0"></h4>
                            <div class="small text-muted">&nbsp;</div>
                            <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                            <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                                <b-button type="button" @click="refreshDenominations()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
                                <span style="width:10px"></span>
                                <b-button type="button" @click="$bvModal.show('help')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
                            </b-button-toolbar>
                            
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12">
                            <b-row>
                                <b-col sm="6" md="4" lg="3" xl="2"  v-for="item in data_denomination_entry" :key="item.id">
                                    <Callout :variant="item.variant">
                                      <center>
                                        <strong class="h6 text-muted">R$ {{ numberFormat(item.value) }}</strong><br>
                                        <small class="text-muted"><img :src="item.image" width="80px" :style="{ width: item.imageWidth +'px' }"></small>
                                        <br>&nbsp;
                                        <br>
                                        <b-form-group>
                                            <b-form-input type="text" :id="item.varname.concat('_ENTRY')" :name="item.varname.concat('_ENTRY')" v-model="item.quantity" v-on:keyup="changeQuantityEntry" placeholder="" v-on:keypress="numbersOnly" style="width: 105px"> </b-form-input>  <small class="text-muted"></small>
                                        </b-form-group>
                                        <small class="text-muted">R$ </small><strong class="h5">{{ numberFormat(item.quantity * item.value) }}</strong><br>
                                      </center>
                                    </Callout>
                                </b-col>
                            </b-row>
                            
                        </b-col>
                    </b-row>



                    <div slot="footer">
                        <b-row class="text-center">
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">Total em Moedas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(data_denomination_entry_total.coins) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="data_denomination_entry_total.coins * 100 / data_denomination_entry_total.total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0 d-md-down-none">
                            <div class="text-muted">Total em Cédulas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(data_denomination_entry_total.notes) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="data_denomination_entry_total.notes * 100 / data_denomination_entry_total.total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">TOTAL</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(data_denomination_entry_total.total) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="data_denomination_entry_total.total * 100 / data_denomination_entry_total.total"></b-progress>
                        </b-col>        
                        </b-row>
                    </div>
                    
                </b-card>
    
               

            </b-col>
        </b-row>




        <b-row v-if="$store.state.currentUnit.id">
            <b-col md="12">
                <b-card header="DENOMINAÇÕES A SEREM TROCADAS">
                  
                    <b-row>
                        <b-col lg="12">
                            <b-row>
                                <b-col sm="6" md="4" lg="3" xl="2"  v-for="item in data_denomination" :key="item.id">
                                    <Callout :variant="item.variant">
                                      <center>
                                        <strong class="h6 text-muted">R$ {{ numberFormat(item.value) }}</strong><br>
                                        <small class="text-muted"><img :src="item.image" width="80px" :style="{ width: item.imageWidth +'px' }"></small>
                                        <br>&nbsp;
                                        <br>
                                        <b-form-group>
                                            <b-form-input type="text" :id="item.varname" :name="item.varname" v-model="item.quantity" v-on:keyup="changeQuantity" placeholder="" v-on:keypress="numbersOnly" style="width: 105px"> </b-form-input>  <small class="text-muted"> / {{ item.totalQuantity }}</small>
                                        </b-form-group>
                                        <small class="text-muted">R$ </small><strong class="h5">{{ numberFormat(item.quantity * item.value) }}</strong><br>
                                      </center>
                                    </Callout>
                                </b-col>
                            </b-row>
                            
                        </b-col>
                    </b-row>



                    <div slot="footer">
                        <b-row class="text-center">
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">Total em Moedas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(data_denomination_total.coins) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="data_denomination_total.coins * 100 / data_denomination_total.total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0 d-md-down-none">
                            <div class="text-muted">Total em Cédulas</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(data_denomination_total.notes) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="data_denomination_total.notes * 100 / data_denomination_total.total"></b-progress>
                        </b-col>
                        <b-col class="mb-sm-2 mb-0">
                            <div class="text-muted">TOTAL</div>
                            <strong><small class="text-muted">R$</small> {{ numberFormat(data_denomination_total.total) }}</strong>
                            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="data_denomination_total.total * 100 / data_denomination_total.total"></b-progress>
                        </b-col>        
                        </b-row>
                    </div>

                       
                    <b-row>
                       
                                <b-col sm="6" md="4" lg="4">
                                    <!--
                                    <Callout variant="danger">
                                        <strong class="h4">CONFIRMAÇÃO OPERADOR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="operator_code" placeholder="" v-model="selectedOperator.name" readonly></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="text" id="operator_name" placeholder="USUÁRIO OPERADOR" v-model="selectedOperator.code" @blur="getOperator()"></b-form-input>
                                        </b-form-group>
                                        
                                        <b-form-group>
                                            <b-form-input type="password" id="operator_password" placeholder="SENHA" v-model="selectedOperator.password" ></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                    -->
                                </b-col>

                                <b-col sm="6" md="4" lg="4">
                                    <Callout variant="primary">
                                        <strong class="h4">AUTORIZAÇÃO SUPERVISOR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="supervisor_code" placeholder="" v-model="selectedSupervisor.name" readonly></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="text" id="supervisor_name" placeholder="USUÁRIO SUPERVISOR" v-model="selectedSupervisor.code" @blur="getSupervisor()"></b-form-input>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-form-input type="password" id="supervisor_password" placeholder="SENHA" v-model="selectedSupervisor.password"></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>

                                


                                <b-col sm="6" md="4" lg="4">
                                    <Callout variant="success">
                                        <strong class="h4">TOTAL ENTRADA</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="total_entry" placeholder="" :value="numberFormat(data_denomination_entry_total.total)" readonly></b-form-input>
                                        </b-form-group>

                                        <strong class="h4">TOTAL A TROCAR</strong><br>
                                        <b-form-group>
                                            <b-form-input type="text" id="total" placeholder="" :value="numberFormat(data_denomination_total.total)" readonly></b-form-input>
                                        </b-form-group>
                                    </Callout>
                                </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="5">
                        <h4 id="traffic" class="card-title mb-0">&nbsp;</h4>
                        <div class="small text-muted">&nbsp;</div>
                        <div class="small text-muted">&nbsp;</div>
                        </b-col>
                        <b-col sm="7" class="d-none d-md-block">
                        <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                            <!--
                            <b-button type="button" @click="templateSave()" variant="success" class="float-right">Salvar Como Modelo</b-button>
                            <span style="width: 10px"></span>
                            -->
                            <b-button type="button" @click="confirmExchange()" variant="danger" class="float-right">Confirmar Troca de Denominação</b-button>

                           
                        </b-button-toolbar>
                        
                        </b-col>
                    </b-row>

                    
                </b-card>
    
               

            </b-col>
        </b-row>
  

        <div>
        <b-modal id="help" title="Ajuda" ok-only size="lg"
        ok-title="Fechar">
            <h3>Controle de Troco - Troca de Denominações</h3>
            <p class="my-4">
            <ol>
                <li>Selecione a quantidade de denominações (moedas e cédulas) a serem trocadas na seção <i>Entrada de Denominações para Troca</i>.</li>
                <li>Selecione a quantidade de denominações (moedas e cédulas) a serem entregues na seção <i>Denominações a Serem Trocadas</i>.<br><i>Obs: Os totalizadores serão exibidos.</i></li>
                <li>Digite o nome do usuário e a senha em <i>Autorização Supervisor</i> para continuar o processo de troca.</li>                
                <li>Clique em <i>Confirmar Troca de Denominação</i>.</li>
            </ol>
            </p>            
        </b-modal>
        </div>


    </div>

</template>

<script>
import Vue from 'vue'

import axios from "axios";
import { Callout } from '@coreui/vue'
import ChangeControlUnitComponent from '../../components/ChangeControlUnitComponent'
import ChangeControlHeaderComponent from '../../components/ChangeControlHeaderComponent'
import ChangeControlItemComponent from '../../components/ChangeControlItemComponent'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

 VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)


export default {
    name: 'dashboard',
    components: {
        Callout,
        ChangeControlUnitComponent,
        ChangeControlHeaderComponent,
        ChangeControlItemComponent,
    },
    data: function() {
        return {
            errorMessage: "",
            selectedOperator: { code: null, name: null, supervisor: false},
            selectedSupervisor: { code: null, name: null, supervisor: true},
          
            confirmDelete: '',

            currentChangeControl: {},

            data_denomination_total: {
                total: 0,
                notes: 0,
                coins: 0
            },

            data_denomination: [],

            data_denomination_entry_total: {
                total: 0,
                notes: 0,
                coins: 0
            },

            data_denomination_entry: [
            ],

            
        }
    },
    computed: {
        currentUserId() {
            return this.$store.state.currentUser.id;
        },
        currentUnitId() {
            return this.$store.state.currentUnit.id;
        }
    },
    watch: {
        currentUnitId(newId, oldId) {
            //console.log("Unit changed: " + oldId + " - " + newId)
            this.getDenominations()
        },
        currentUserId(newId, oldId) {
            //console.log("Operator changed: " + oldId + " - " + newId)

            this.selectedSupervisor.name = this.$store.state.currentUser.name;
            this.selectedSupervisor.code = this.$store.state.currentUser.code;
        },
    },
    methods: {
        changeQuantityEntry() {

            var notes = 0;
            var coins = 0;
            this.data_denomination_entry.forEach(function(item) {
            if(item.type == 1)
                coins += item.quantity * item.value
            else
                notes += item.quantity * item.value
            })

            this.data_denomination_entry_total.coins = coins
            this.data_denomination_entry_total.notes = notes
            this.data_denomination_entry_total.total = coins + notes
        },


        changeQuantity() {

          var notes = 0;
          var coins = 0;
          this.data_denomination.forEach(function(item) {
            if(item.type == 1)
               coins += item.quantity * item.value
            else
               notes += item.quantity * item.value
          })
          this.data_denomination_total.coins = coins
          this.data_denomination_total.notes = notes
          this.data_denomination_total.total = coins + notes
        },

        async getDenominationsEntry() {
            try {
                if(this.$store.state.currentUser.code && this.$store.state.currentUnit.originId) {
                    //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    const denominationsResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/denominations?originId=" + this.$store.state.currentUnit.originId + "&operatorCode=" + this.$store.state.currentUser.code
                    );
                    this.data_denomination_entry = denominationsResponse.data.controlDenominations
                    this.currentChangeControl = denominationsResponse.data
                }
                else {
                     this.data_denomination_entry = []
                }
                this.changeQuantityEntry();
            } catch (e) {
                console.log(e)                 
            }  
        },

        async getDenominations() {
            try {
                if(this.$store.state.currentUser.code && this.$store.state.currentUnit.originId) {
                    //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    const denominationsResponse = await axios.get(
                        this.$store.state.ws_url + "/changecontrol/denominations?originId=" + this.$store.state.currentUnit.originId + "&operatorCode=" + this.$store.state.currentUser.code
                    );
                    this.data_denomination = denominationsResponse.data.controlDenominations
                    this.currentChangeControl = denominationsResponse.data
                }
                else {
                     this.data_denomination = []
                }
                this.changeQuantity();
            } catch (e) {
                console.log(e)                 
            }  
        },

        
        async checkPassword(userCode, password) {
            await axios.get(
                this.$store.state.ws_url + "/sgap/operator?code=" + userCode + "&password=" + password
            ).then(() => {
                return resp;
            }).catch(()=> {
                return 0;
            });

            return resp;
        },

        async getSupervisor() {
            try {
                if(this.selectedSupervisor.code) {
                    const supervisorResponse = await axios.get(
                        this.$store.state.ws_url + "/sgap/operator?code=" + this.selectedSupervisor.code
                    );
                    //this.data_denomination = denominationsResponse.data
                    this.selectedSupervisor = supervisorResponse.data                    
                }
                else {
                    this.selectedSupervisor = { code: null, name: null, supervisor: true}
                }
            } catch (e) {
                console.log(e)                
            }
        },

        async saveDenominationExchange() {
            try {

                var movement = {}
                var movementDenominationsEntry = new Array;
                var movementDenominations = new Array;

                console.log(this.currentChangeControl)
                movement.changeControlId = this.currentChangeControl.id
                movement.supervisorCode = this.selectedSupervisor.code
                movement.supervisorPwd = this.selectedSupervisor.password
                
                this.data_denomination.forEach( den => {
                    if(den.quantity > 0) {
                        var denom = { quantity: den.quantity, denomination: { id: den.id }  }
                        movementDenominations.push(denom)
                    }
                })
                movement.denominations = movementDenominations

                this.data_denomination_entry.forEach( den => {
                    if(den.quantity > 0) {
                        var denom = { quantity: den.quantity, denomination: { id: den.id }  }
                        movementDenominationsEntry.push(denom)
                    }
                })
                movement.denominationsEntry = movementDenominationsEntry

                console.log(movement)

                //console.log(this.$store.state.ws_url + "/changecontrol/movement?typeCode=4&status=4&originId=" + this.$store.state.currentUnit.originId)
                    
                await axios.post(
                    this.$store.state.ws_url + "/changecontrol/exchange",
                    movement
                );                    
                console.log(resp)
                this.refreshDenominations() 
                this.showInfoMsg({title: "Troca de Denominação", message: "Troca de denominação realizada" })
                
            } catch (e) {
                console.log(e)                 
                this.showErrorMsg({title: "Troca de Denominação", message: "Erro ao realizar troca de denominação" })
            }  
        },

       
        numberFormat(x) {
            return parseFloat(x).toFixed(2).toString().replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        variant(value) {
            let $variant
            if (value <= 25) {
                $variant = 'info'
            } else if (value > 25 && value <= 50) {
                $variant = 'success'
            } else if (value > 50 && value <= 75) {
                $variant = 'warning'
            } else if (value > 75 && value <= 100) {
                $variant = 'danger'
            }
            return $variant
        },
        confirmExchange() {
            this.errorMessage = ""
            
            if(this.data_denomination_entry_total.total <= 0) {
                this.errorMessage = "Nenhuma denominação selecionada para troca."
            }
            else
            if(this.data_denomination_total.total != this.data_denomination_entry_total.total) {
                this.errorMessage = "Quantidade de denominações de troca com valores diferentes."
            }
            else {
                // Verifica quantidade de denominações
                var den_values = new Array
                this.data_denomination.forEach( den => {
                        if(den.quantity > 0 && den.quantity > den.totalQuantity) {
                            den_values.push( den.value )
                        }
                    })
                if(den_values && den_values.length > 0) {
                    var den_msg = ""
                    var den_sep = ""
                    den_values.forEach( den => {
                        den_msg += den_sep + this.numberFormat(den)
                        den_sep = ", "
                    })
                    this.errorMessage = "Verifique a quantidade disponível das denominações: R$ " + den_msg
                }
            }

            if(this.errorMessage == "") {
                if(this.selectedSupervisor.name == null || this.selectedSupervisor.name.trim().length <= 0) {
                    this.errorMessage = "Necessário autorização do Supervisor."    
                }
                else
                if(this.selectedSupervisor.password == null || this.selectedSupervisor.password.trim().length <= 0) {
                    this.errorMessage = "Favor preencher a senha do Supervisor.";
                }                
            }


            if( this.errorMessage.trim() != "") {
                //this.messageGeneric("Confirmar Saída", this.errorMessage)
                this.showErrorMsg({title: "Confirmar Troca de Denominação", message: this.errorMessage })
            }
            else {
                console.log("Troca de denominação realizada");
                this.saveDenominationExchange();

                
            }    
            
        },
        numbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        messageGeneric(label, message) {
            this.$bvModal.msgBoxOk(message, {
            title: label,
            okTitle: 'OK',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                return true
            })
            .catch(err => {
                return false
            })
        },
        refreshDenominations() {
            this.changeQuantity()
            this.getDenominations()
            this.getDenominationsEntry()
        },



    },
    mounted: function(){
        this.changeQuantity()
        this.getDenominations()
        this.getDenominationsEntry()

        this.selectedSupervisor.name = this.$store.state.currentUser.name;
        this.selectedSupervisor.code = this.$store.state.currentUser.code;
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Hello there',
        message: 'That\'s the success!'
        },
        showInfoMsg: {
        type: VueNotifications.types.info,
        title: 'Hey you',
        message: 'Here is some info for you'
        },
        showWarnMsg: {
        type: VueNotifications.types.warn,
        title: 'Wow, man',
        message: 'That\'s the kind of warning'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Erro',
        message: ""
        }
    }
}
</script>


<style>
</style>
